import React from 'react';
import { ErrorMessage } from 'formik';
import Grid from '@material-ui/core/Grid';
import get from 'get-value';
import classNames from 'classnames';
import { InputsProps } from './interface';
import ValidationIcon from '../Icons/ValidationIcon';
import Input from 'shared/Inputs/Input';

const FormInput: React.FC<InputsProps> = ({ field, form, transformValue, ...props }) => {
  const { name } = field;
  const { touched, errors } = form;
  const {
    label,
    labelClass = 'form__label',
    inputClass = 'form__input',
    helperText,
    placeholder,
    position = '',
    inputWidth = 5,
    iconWidth = 6,
    wrapperClass = 'form__wrapper form__item',
    showBorder = true,
    mask,
    showMask = false,
    spacing = 1,
    handleBlur,
    withIcon = true,
    showError = true,
    type,
    required,
  } = props as any;

  const inputWrapperClass = position === 'row' ? 'form__input-wrapper' : undefined;
  const nestedError = get(errors, name);
  const nestedTouched = get(touched, name);

  const containerClass = classNames(wrapperClass, {
    'form__field-error': nestedTouched && nestedError && showError,
    'no-border': !showBorder,
  });

  return (
    <div className={containerClass}>
      <div className={inputWrapperClass}>
        <label htmlFor={name} className={position === 'row' ? `${labelClass} form__inline-label` : labelClass}>
          {label} {required && <span className="asterisk">*</span>}
        </label>

        {helperText && <div className="form__helper-text">{helperText}</div>}
        <Grid container spacing={spacing} alignItems="center">
          <Grid item xs={inputWidth} className="form-grid__item--big">
            <Input
              id={name}
              {...field}
              field={field}
              className={position === 'row' ? `${inputClass} ${inputClass}--row` : inputClass}
              placeholder={placeholder}
              mask={mask}
              form={form}
              showMask={showMask}
              handleBlur={handleBlur}
              type={type}
              transformValue={transformValue}
            />
          </Grid>
          {withIcon && showError && (
            <Grid item xs={iconWidth} className="form-grid__item--small">
              <ValidationIcon hasError={!!nestedError} wasTouched={!!nestedTouched} />
            </Grid>
          )}
        </Grid>
        {position !== 'row' && showError && (
          <ErrorMessage className="error-message coral" component="div" name={name} />
        )}
      </div>
    </div>
  );
};

export default FormInput;
